// actions
export const getCertificateLevel = 'getCertificateLevel'
export const getAuth = 'getAuth'
// mutations
export const SET_LEVEL_INFO = 'SET_LEVEL_INFO'
export const REMOVE_LEVEL_INFO = 'REMOVE_LEVEL_INFO'
export const SET_AUTH_INFO = 'SET_AUTH_INFO'
